import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order } from 'src/app/interfaces/common/order';
import { FilterData } from 'src/app/interfaces/core/filter-data';
import { ResponsePayload } from 'src/app/interfaces/core/response-payload.interface';
import { environment } from 'src/environments/environment';
const API_ORDER = environment.apiBaseLink + '/api/order/';
const API_ORDER_DASHBOARD = environment.apiBaseLink + '/api/dashboard/';
@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(
    private httpClient: HttpClient
  ) {
  }

  /**
   * addOrder
   * getOrdersByUser
   * getOrderById
   * updateOrderById
   */

  addOrder(data: Order) {
    return this.httpClient.post<ResponsePayload>
    (API_ORDER + 'add-order-by-user', data);
  }

  addOrderByGuest(data: Order) {
    return this.httpClient.post<ResponsePayload>
    (API_ORDER + 'add-order-by-guest', data);
  }


  allOrderDashboard(data: Order) {
    return this.httpClient.post<ResponsePayload>
    (API_ORDER_DASHBOARD + 'user-dashboard', data);
  }

  getOrdersByUser(filterData: FilterData, searchQuery?: string) {
    let params = new HttpParams();
    if (searchQuery) {
      params = params.append('q', searchQuery);
    }
    return this.httpClient.post<{ data: Order[], count: number, success: boolean }>(API_ORDER + 'get-orders-by-user', filterData, {params});
  }


  getOrderById(id: string, select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.get<{ data: Order, message: string, success: boolean }>(API_ORDER + id, {params});
  }

  getOrderIdById(id: string, select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.get<{ data: Order, message: string, success: boolean }>(API_ORDER +'order-id/'+ id, {params});
  }

  updateOrderById(id: string, data: Order) {
    return this.httpClient.put<{ message: string, success: boolean }>(API_ORDER + 'update-by-user/' + id, data);
  }


  addReviewOrderById(id: string, data: Order) {
    return this.httpClient.put<{ message: string, success: boolean }>(API_ORDER + 'add-review-by-user/' + id, data);
  }

  updateOrderPaymentIdById(id: string,  data: any) {
    return this.httpClient.put<{ message: string, success: boolean }>(API_ORDER + 'update-by-user/' + id, data);
  }


  updateOrderSessionKey(id: string, data: any) {
    return this.httpClient.put<{ message: string, success: boolean }>(API_ORDER + 'update-order-session-key/' + id, data);
  }

  checkFraudOrder(phoneNo: string) {
    return this.httpClient.get<ResponsePayload>(API_ORDER + 'check-fraud-order/' + phoneNo);
  }
}
